import { Outlet, useLocation } from "react-router-dom";
import { Rail } from "./Rail";
import { BottomNav } from "./BottomNav";
import { OutdatedAppBanner } from "./OutdatedAppBanner";
import { ErrorBoundary } from "@/shared/ui";
import { UnreadProvider } from "@/shared/unread/UnreadProvider";
import { AssistantWidget } from "@/shared/assistant/AssistantWidget";
import { useIsMobile } from "@/shared/useMediaQuery";
import { MobileTopBar, haTestataPropria } from "./MobileTopBar";
import { CercaRapida } from "./CercaRapida";

function AppShellInner() {
  // Un solo listener per tutta l'app: telefono e computer montano barre
  // DIVERSE (non le nascondono), cosi' i poller dei badge girano una volta.
  const isMobile = useIsMobile();
  const { pathname } = useLocation();

  if (isMobile) {
    // Telefono (redesign 2026-10-23, Pixel 9): barra in alto col nome della
    // pagina e la campanella, contenuto che scorre, barra in basso. Le pagine
    // di dettaglio hanno la loro testata con la freccia indietro. La
    // campanella nelle pagine di dettaglio non c'e': si torna indietro e la
    // si trova nella barra.
    return (
      <div className="flex h-dvh min-h-dvh flex-col overflow-hidden bg-paper">
        {!haTestataPropria(pathname) && (
          <MobileTopBar campanella={<AssistantWidget variant="bar" />} />
        )}
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <OutdatedAppBanner />
          <ErrorBoundary label="Pagina">
            <Outlet />
          </ErrorBoundary>
        </div>
        <BottomNav />
        <CercaRapida />
      </div>
    );
  }

  return (
    // Desktop: griglia 80px (rail) + 1fr.
    //
    // `grid-template-rows: minmax(0,1fr)` non e' un dettaglio: senza, la riga
    // vale `auto` e si dimensiona sul CONTENUTO. La colonna contenuto cresceva
    // oltre l'altezza della finestra e `overflow-hidden` tagliava quello che
    // avanzava — in fondo, dove stanno i tasti. Su Messaggi a 720px di altezza
    // sforava di 23px e il composer restava monco (Davide 2026-08-24, "non ho
    // i tasti per inviare"). Con la riga vincolata, il contenuto si stringe e
    // scorre al suo interno invece di sfondare, e vale per OGNI pagina.
    <div className="grid min-h-dvh h-dvh overflow-hidden [grid-template-rows:minmax(0,1fr)] [grid-template-columns:80px_1fr]">
      <Rail />
      <div className="flex min-h-0 flex-col overflow-hidden">
        <OutdatedAppBanner />
        {/* Boundary di pagina: un crash di rendering in qualunque route
            non blanka piu' l'intera app, mostra fallback con stack +
            "Riprova". La rail resta sempre navigabile. */}
        <ErrorBoundary label="Pagina">
          <Outlet />
        </ErrorBoundary>
      </div>
      {/* Campanella notifiche flottante: solo area autenticata (non su /login).
          fixed bottom-right, si posiziona da solo sopra il VersionBadge. */}
      <AssistantWidget />
      {/* Ctrl+K da ogni pagina: un ordine o una pagina per nome. */}
      <CercaRapida />
    </div>
  );
}

export function AppShell() {
  return (
    <UnreadProvider>
      <AppShellInner />
    </UnreadProvider>
  );
}
